<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.region.list")}}</span>
    <div class="list-container">
      <AveineRegionList :APIbaseURL="APIbaseURL" :adminMode="true"/>
    </div>
  </div>
</template>

<script>
import { AveineRegionList } from 'aveine-region/src/wrapper';
export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineRegionList
  }
}
</script>
